import remoteWarningSelectorDefinition from './remote-warning.js';
import availabilitySelectorDefinition from './availability.js';
import exchangeableAssetsSelectors from './exchangeable-assets.js';
const exchangeSelectors = [
    availabilitySelectorDefinition,
    remoteWarningSelectorDefinition,
    ...exchangeableAssetsSelectors,
];
export default exchangeSelectors;
